import React from 'react';

export const brl = (n) =>
  n == null || isNaN(n)
    ? '—'
    : 'R$ ' + Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function mascaraMoeda(texto) {
  const d = String(texto).replace(/\D/g, '').replace(/^0+/, '').slice(0, 7);
  return d ? parseInt(d, 10).toLocaleString('pt-BR') : '';
}

export const numeroDeMascara = (texto) => {
  const d = String(texto).replace(/\D/g, '');
  return d ? parseInt(d, 10) : 0;
};

export const UFS = ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RR', 'RJ', 'RN', 'RO', 'RS', 'SC', 'SE', 'SP', 'TO'];

export const Campo = ({ titulo, dica, children, testId }) => (
  <div className="py-5 border-t border-slate-200 first:border-t-0 first:pt-1" data-testid={testId}>
    <label className="block font-semibold text-[15px] text-slate-900">{titulo}</label>
    {dica && <span className="block text-[13px] text-slate-500 mt-0.5 mb-3">{dica}</span>}
    <div className={dica ? '' : 'mt-3'}>{children}</div>
  </div>
);

export const Opcoes = ({ valor, onChange, opcoes, testPrefix }) => (
  <div className="flex flex-wrap gap-2">
    {opcoes.map((o) => {
      const v = typeof o === 'string' ? o : o.v;
      const label = typeof o === 'string' ? o : o.label;
      const ativo = valor === v;
      return (
        <button
          key={v}
          type="button"
          onClick={() => onChange(v)}
          data-testid={`${testPrefix}-${String(v).toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          aria-pressed={ativo}
          className={`flex-1 min-w-[96px] rounded-[10px] border px-3 py-2.5 text-[14.5px] transition-colors ${
            ativo
              ? 'bg-primary border-primary text-white font-semibold'
              : 'bg-white border-slate-300 text-slate-600 hover:border-primary/60 hover:text-primary'
          }`}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export const Moeda = ({ valor, onChange, placeholder = '0', testId }) => (
  <div className="relative">
    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 font-mono text-[15px] pointer-events-none">R$</span>
    <input
      inputMode="numeric"
      value={valor}
      placeholder={placeholder}
      data-testid={testId}
      onChange={(e) => onChange(mascaraMoeda(e.target.value))}
      className="w-full rounded-[10px] border border-slate-300 bg-white pl-11 pr-14 py-2.5 font-mono text-[18px] font-medium tabular-nums focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary"
    />
    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 font-mono text-[15px] pointer-events-none">,00</span>
  </div>
);

export const Tile = ({ k, v, s, destaque, testId }) => (
  <div className="rounded-xl border border-slate-200 bg-white px-3.5 py-3" data-testid={testId}>
    <div className="text-[11px] font-semibold uppercase tracking-[0.1em] text-slate-400">{k}</div>
    <div className={`mt-1.5 font-mono text-[19px] font-medium tabular-nums tracking-tight ${destaque || 'text-slate-900'}`}>{v}</div>
    <div className="mt-0.5 min-h-[18px] text-[12px] text-slate-500">{s}</div>
  </div>
);

export const Grupo = ({ nome, bloco }) => (
  <div className="flex items-center justify-between gap-3 border-b border-slate-200 py-2.5 text-[14px]">
    <span className="text-slate-700">
      {nome} {bloco?.n ? <span className="font-mono text-[12.5px] text-slate-400">({bloco.n})</span> : null}
    </span>
    <span className="font-mono font-medium tabular-nums whitespace-nowrap text-slate-900">
      {bloco?.n ? brl(bloco.mediana) : <span className="text-slate-400 font-sans font-normal">sem resposta</span>}
    </span>
  </div>
);
